// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-title[data-v-be34583a]{font-size:16px;color:#333;font-weight:700;padding-right:8px}", ""]);
// Exports
module.exports = exports;
